export const mapAudioFormClipToClipPositions = (
  clip: {
    readPosition?: number
    positionInSecond?: number
    forcedDuration?: number
    fadeIn?: number
    fadeOut?: number
    position?: number
    marginStart?: number
  },
  duration: number
): {
  startAt: number
  startOffset: number
  endOffset: number
  duration: number
  fadeIn: number
  fadeOut: number
} => {
  const startOffset = clip.marginStart ?? 0
  const paddingEnd = clip.forcedDuration
    ? duration - clip.forcedDuration - startOffset
    : 0

  return {
    startAt: (clip.position ?? 0) - startOffset,
    startOffset,
    endOffset: paddingEnd ? -paddingEnd : 0,
    duration,
    fadeIn: clip.fadeIn ?? 0,
    fadeOut: clip.fadeOut ?? 0,
  }
}
